import {Observable} from 'rxjs';
import {distinctUntilChanged, filter, pluck} from 'rxjs/operators';

import Playback from '../../../State/Stores/Playback/Playback';

import ISolution from '../Interfaces/ISolution';

const MARGIN_OF_ERROR = 0.1;

const filterTimeUpdates = (solutionCurrentTime: number, nextCurrentTime: number): boolean => {
    const delta = Math.abs(nextCurrentTime - solutionCurrentTime);

    return delta > MARGIN_OF_ERROR;
};

const subscribeToTimeUpdate = (playbackStoreUpdate$: Observable<Playback>, solution: ISolution) =>
    playbackStoreUpdate$
        .pipe(
            pluck('currentTime'),
            distinctUntilChanged(),
            filter((nextCurrentTime: number) => filterTimeUpdates(solution.state.currentTime, nextCurrentTime))
        )
        .subscribe((nextCurrentTime: number) => solution.seek(nextCurrentTime));

export default subscribeToTimeUpdate;